import { Injectable } from "@angular/core";
import { CFJobType, ChildProject } from "../models/projects/project.model";
import { Query, ResolverParams, ResolverService } from "./api/resolver.service";
import { KFeathers } from "./api/feathers.service";
import { ProjectService } from "./project.service";
import { MasterProject } from "../models/projects/master-project.model";

export enum JobTypeEnum {
    MASTER = 'Refonte',
    GAMME_EXISTANTE = 'Gamme Existante',
    INNOVATION = 'Innovation',
    LOWBUDGET = 'LowBudget',
    LOGO_EXE = 'Logo à Exécuter'
}



@Injectable({
    providedIn: 'root',
})
export class MasterProjectService extends ResolverService<MasterProject> {
    path: string = 'project';
    model: new (any: any) => MasterProject = MasterProject;


    constructor(protected feathers: KFeathers, protected s_project: ProjectService) {
        super(feathers);
        this.s_project.current$.subscribe(async (project: ChildProject | undefined) => {
            if (project && project.type === CFJobType.JOB_ENFANT && project.id_maitre) {
                const master = (await this.find({ identifier: project.id_maitre }))[0];
                if (master) {
                    this.emitCurrent(master);
                }
            }
        });
    }

    override async find(queries?: Query, params?: ResolverParams): Promise<MasterProject[]> {
        return super.find({ ...queries, type: CFJobType.JOB_MAITRE }, params);
    }

    override async get(id: string, queries?: Query, params?: ResolverParams): Promise<MasterProject> {
        return super.get(id, { ...queries, type: CFJobType.JOB_MAITRE }, params);
    }
}